module.exports = __webpack_public_path__ + "static/img/hone-zxzx.0efb342.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hone-zxzx.png
// module id = y+Yw
// module chunks = 0